import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='flex-1 flex items-center justify-center'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold text-gray-900 mb-4'>404</h1>
        <p className='text-gray-600 mb-4'>{t('notFound.message')}</p>
        <div className='flex gap-4 justify-center'>
          <button
            onClick={() => navigate('/')}
            className='px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors'
          >
            {t('notFound.goHome')}
          </button>
          <button
            onClick={() => navigate(-1)}
            className='px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors'
          >
            {t('notFound.backToPrevious')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
